import styled from 'styled-components'

export const WrapperSlider = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`

export const SlideTrack = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
}
`
